import { useState } from "react";
import Radio from "@mui/material/Radio";
import styled from "styled-components";
import DialogContent from "@mui/material/DialogContent";
import { Box } from "@mui/system";
import { Close } from "@mui/icons-material";
import { DialogTitle, IconButton } from "@mui/material";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { authData } from "../../../redux/auth/authSlice";
import { useSelector } from "react-redux";
import { LoadingButton } from "@mui/lab";
import { StyledButtons } from "../RegisterForm/RegisterFrom";
import { useQueryParams } from "../../../Hooks/useQueryParams";
import Swal from "sweetalert2";
import config, { Theme } from "../../../config/aws-exports";
import { API } from "aws-amplify";

import "./feedbackform.css";

import Rating from "@mui/material/Rating";

export const StyledGrid = styled.div`
  padding: 1.5rem;
  display: grid;
  grid-template-columns: 350px 100px 100px 130px 100px 100px;
  grid-template-rows: auto;
  grid-row-gap: 0.5rem;
  text-align: center;
  overflow-x: auto;
  .led {
    text-align: left;
  }
  .left {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
`;

export default function FeedbackForm({ handleClose, refetch }) {
  const userDetails = useSelector(authData);
  const query = useQueryParams();
  const [loading, setLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedValue2, setSelectedValue2] = useState("");
  const [selectedValue3, setSelectedValue3] = useState("");
  const [selectedValue4, setSelectedValue4] = useState("");
  const [selectedValue5, setSelectedValue5] = useState("");
  const [selectedValue6, setSelectedValue6] = useState("");
  const [selectedValue7, setSelectedValue7] = useState("");
  const [selectedValue8, setSelectedValue8] = useState("");
  const [selectedValue9, setSelectedValue9] = useState("");
  const [selectedValue10, setSelectedValue10] = useState("");
  const [selectedValue11, setSelectedValue11] = useState("");
  const [question2, setQuestion2] = useState("");
  const [question3, setQuestion3] = useState("");
  const [question1Desc, setQuestion1Desc] = useState("");
  const [question2Desc, setQuestion2Desc] = useState("");
  const [question3Desc, setQuestion3Desc] = useState("");
  const [question4Desc, setQuestion4Desc] = useState("");
  const [question5Desc, setQuestion5Desc] = useState("");
  const [question6, setQuestion6] = useState("");
  const [question7, setQuestion7] = useState("");
  const [organization] = useState("");
  const [designation] = useState("");
  const [department] = useState("");
  const [error, setError] = useState("");

  const [sessionRating, setSessionRating] = useState(0);
  const [instructorRating, setInstructorRating] = useState(0);
  const [impactRating, setImpactRating] = useState(0);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };
  const handleChange2 = (event) => {
    setSelectedValue2(event.target.value);
  };
  const handleChange3 = (event) => {
    setSelectedValue3(event.target.value);
  };
  const handleChange4 = (event) => {
    setSelectedValue4(event.target.value);
  };
  const handleChange5 = (event) => {
    setSelectedValue5(event.target.value);
  };
  const handleChange6 = (event) => {
    setSelectedValue6(event.target.value);
  };
  const handleChange7 = (event) => {
    setSelectedValue7(event.target.value);
  };
  const handleChange8 = (event) => {
    setSelectedValue8(event.target.value);
  };
  const handleChange9 = (event) => {
    setSelectedValue9(event.target.value);
  };
  const handleChange10 = (event) => {
    setSelectedValue10(event.target.value);
  };
  const handleChange11 = (event) => {
    setSelectedValue11(event.target.value);
  };

  const controlProps = (item) => ({
    checked: selectedValue === item,
    onChange: handleChange,
    value: item,
    name: "size-radio-button-demo",
    inputProps: { "aria-label": item },
  });
  const controlProps2 = (item) => ({
    checked: selectedValue2 === item,
    onChange: handleChange2,
    value: item,
    name: "size-radio-button-demo-2",
    inputProps: { "aria-label": item },
  });
  const controlProps3 = (item) => ({
    checked: selectedValue3 === item,
    onChange: handleChange3,
    value: item,
    name: "size-radio-button-demo-3",
    inputProps: { "aria-label": item },
  });
  const controlProps4 = (item) => ({
    checked: selectedValue4 === item,
    onChange: handleChange4,
    value: item,
    name: "size-radio-button-demo-4",
    inputProps: { "aria-label": item },
  });
  const controlProps5 = (item) => ({
    checked: selectedValue5 === item,
    onChange: handleChange5,
    value: item,
    name: "size-radio-button-demo-5",
    inputProps: { "aria-label": item },
  });
  const controlProps6 = (item) => ({
    checked: selectedValue6 === item,
    onChange: handleChange6,
    value: item,
    name: "size-radio-button-demo-6",
    inputProps: { "aria-label": item },
  });
  const controlProps7 = (item) => ({
    checked: selectedValue7 === item,
    onChange: handleChange7,
    value: item,
    name: "size-radio-button-demo-7",
    inputProps: { "aria-label": item },
  });
  const controlProps8 = (item) => ({
    checked: selectedValue8 === item,
    onChange: handleChange8,
    value: item,
    name: "size-radio-button-demo-8",
    inputProps: { "aria-label": item },
  });
  const controlProps9 = (item) => ({
    checked: selectedValue9 === item,
    onChange: handleChange9,
    value: item,
    name: "size-radio-button-demo-9",
    inputProps: { "aria-label": item },
  });
  const controlProps10 = (item) => ({
    checked: selectedValue10 === item,
    onChange: handleChange10,
    value: item,
    name: "size-radio-button-demo-10",
    inputProps: { "aria-label": item },
  });
  const controlProps11 = (item) => ({
    checked: selectedValue11 === item,
    onChange: handleChange11,
    value: item,
    name: "size-radio-button-demo-11",
    inputProps: { "aria-label": item },
  });

  const handleChangeQ2 = (event) => {
    setQuestion2(event.target.value);
  };
  const handleChangeQ3 = (event) => {
    setQuestion3(event.target.value);
  };

  const handleSubmit = async () => {
    if (sessionRating === 0 && instructorRating === 0 && impactRating === 0) {
      setError("Answer all the sub questions in question 1");
      return;
    } else {
      setError("");
    }
    if (
      selectedValue === "" ||
      selectedValue2 === "" ||
      selectedValue3 === "" ||
      selectedValue4 === "" ||
      selectedValue5 === ""
    ) {
      setError("Answer all the sub questions in question 2");
      return;
    } else {
      setError("");
    }
    if (question2 === "") {
      setError("Choose any option for question 3");
      return;
    } else {
      setError("");
    }
    if (question3 === "") {
      setError("Choose any option for question 4");
      return;
    } else {
      setError("");
    }
    if (
      selectedValue6 === "" ||
      selectedValue7 === "" ||
      selectedValue8 === "" ||
      selectedValue9 === ""
    ) {
      setError("Answer all the sub questions in question 5");
      return;
    } else {
      setError("");
    }
    if (selectedValue10 === "" || selectedValue11 === "") {
      setError("Answer all the sub questions in question 6");
      return;
    } else {
      setError("");
    }

    if (question6 === "") {
      setError("Question 7  answer is required");
      return;
    } else {
      setError("");
    }
    if (question7 === "") {
      setError("Question 8  answer is required");
      return;
    } else {
      setError("");
    }
    // if (organization === "") {
    //   setError("Organization is required");
    //   return;
    // } else {
    //   setError("");
    // }
    // if (designation === "") {
    //   setError("Designation is required");
    //   return;
    // } else {
    //   setError("");
    // }
    // if (department === "") {
    //   setError("Department is required");
    //   return;
    // } else {
    //   setError("");
    // }
    const values = {
      ratings: {
        sessionRate: sessionRating,
        instructorRate: instructorRating,
        impactRate: impactRating,
      },
      q1: {
        s1: parseInt(selectedValue),
        s2: parseInt(selectedValue2),
        s3: parseInt(selectedValue3),
        s4: parseInt(selectedValue4),
        s5: parseInt(selectedValue5),
        s6: question1Desc,
      },
      q2: { s1: parseInt(question2), s2: question2Desc },
      q3: { s1: parseInt(question3), s2: question3Desc },
      q4: {
        s1: parseInt(selectedValue6),
        s2: parseInt(selectedValue7),
        s3: parseInt(selectedValue8),
        s4: parseInt(selectedValue9),
        s5: question4Desc,
      },
      q5: {
        s1: parseInt(selectedValue10),
        s2: parseInt(selectedValue11),
        s3: question5Desc,
      },
      q6: question6,
      q7: question7,
      org: organization,
      design: designation,
      depart: department,
    };
    const bodyParam = {
      body: {
        fd: values,
        ur_id: userDetails?.uData?.ur_id,
        sid: query.get("sid"),
      },

      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        // Authorization: jwttoken,
      },
    };
    console.log(JSON.stringify(bodyParam, null, 2));
      try {
        setLoading(true);
        const response = await API.post(
          config.aws_cloud_logic_custom_name,
          "/addFeedBack",
          bodyParam
        );
        console.log({response})
        // window.location.reload();
        setLoading(false);

        Swal.fire({
          title: "Success",
          text: "Successfully submitted your feedback",
          icon: "success",
          confirmButtonColor: Theme.color.primary,
          confirmButtonText: "Ok",
        }).then((willDelete) => {
          if (willDelete.isConfirmed) {
            refetch();
            handleClose();
          }
        });
      } catch (error) {
        setLoading(false);
      }
  };

  return (
    <>
      <DialogTitle id="responsive-dialog-title" sx={{ position: "relative" }}>
        {"Please provide your feedback"}
        <IconButton
          onClick={() => {
            handleClose();
          }}
          sx={{ position: "absolute", right: 10, top: 10 }}
        >
          <Close sx={{ fontSize: "2rem" }} />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <p>Q1. Please rate how much you have satisfied ?</p>

        <div className="feedback">
          <div className="feedback-heading">Session Rating</div>
          <div style={{marginLeft:'220px'}}>
            <Rating
              value={sessionRating}
              precision={0.5}
              size="large"
              className="star-icon"
              onChange={(_, newValue) => {
                setSessionRating(newValue);
              }}
            />
          </div>
        </div>

        <div className="feedback">
          <div className="feedback-heading">Instructor Rating</div>
       
        <div style={{marginLeft:'220px'}}>
          <Rating
            value={instructorRating}
            precision={0.5}
            size="large"
            // className="star-icon"
            onChange={(_, newValue) => {
              setInstructorRating(newValue);
            }}
          />
          </div>
      </div>
      <div className="feedback">
        <div className="feedback-heading">Impact Rating</div>
        
          <div style={{marginLeft:'220px'}}>
            <Rating
              value={impactRating}
              precision={0.5}
              size="large"
              // className="star-icon"
              onChange={(_, newValue) => {
                setImpactRating(newValue);
              }}
            />
          </div>
        </div>

        <p>
          Q2.Please indicate the extent to which you agree or disagree with each
          statement below.Please select an answer for each statement.
        </p>
        <StyledGrid>
          <p></p>
          <p>Strongly disagree</p>
          <p>Disagree</p>
          <p>Neither disagree nor agree</p>
          <p>Agree</p>
          <p>Strongly agree</p>
          <p className="led">
            Knowledge receiver from the course will positively impact the
            quality of my work
          </p>
          {["0", "1", "2", "3", "4"].map((item) => (
            <p>
              <Radio {...controlProps(item)} />
            </p>
          ))}
          <p className="left">
            <p>Exercises and activities were useful</p>
          </p>
          {["0", "1", "2", "3", "4"].map((item) => (
            <p>
              <Radio {...controlProps2(item)} />
            </p>
          ))}
          <p className="left">
            <p>Training materials / presentation were useful</p>
          </p>
          {["0", "1", "2", "3", "4"].map((item, id) => (
            <p>
              <Radio {...controlProps3(item, id)} />
            </p>
          ))}

          <p className="left">
            <p>I am satisfied with this course overall</p>
          </p>
          {["0", "1", "2", "3", "4"].map((item, id) => (
            <p>
              <Radio {...controlProps4(item, id)} />
            </p>
          ))}
          <p className="led">
            There are others in my organization who would benefit from this USP
            Education course
          </p>
          {["0", "1", "2", "3", "4"].map((item, id) => (
            <p>
              <Radio {...controlProps5(item, id)} />
            </p>
          ))}
        </StyledGrid>
        <Box sx={{ pl: 3, mb: 1.5 }}>
          <p>Additional comments (optional)</p>
          <Box
            component="textarea"
            onChange={(e) => setQuestion1Desc(e.target.value)}
            sx={{ width: "100%", resize: "none", p: 1 }}
          />
        </Box>
        <p>Q3. Regarding the course content, please choose one</p>

        <FormControl component="fieldset">
          <RadioGroup
            aria-label="gender"
            defaultValue=""
            name="radio-buttons-group-234"
            value={question2}
            onChange={handleChangeQ2}
          >
            <FormControlLabel
              value="0"
              control={<Radio />}
              label="The course content was appropriate for my level of knowledge."
            />
            <FormControlLabel
              value="1"
              control={<Radio />}
              label="The course content was too elementary."
            />
            <FormControlLabel
              value="2"
              control={<Radio />}
              label="The pace of the course was too fast"
            />
          </RadioGroup>
        </FormControl>
        <Box sx={{ pl: 3 }}>
          <p>Additional comments (optional)</p>
          <Box
            component="textarea"
            onChange={(e) => setQuestion2Desc(e.target.value)}
            sx={{ width: "100%", resize: "none", p: 1 }}
          />
        </Box>
        <p>Q4. Regarding the pace of the course. please choose one</p>

        <FormControl component="fieldset">
          <RadioGroup
            aria-label="pace"
            defaultValue=""
            name="radio-buttons-group-2345"
            value={question3}
            onChange={handleChangeQ3}
          >
            <FormControlLabel
              value="0"
              control={<Radio />}
              label="I am satisfied with the pace of the course."
            />
            <FormControlLabel
              value="1"
              control={<Radio />}
              label="The pace of the was too slow."
            />
            <FormControlLabel
              value="2"
              control={<Radio />}
              label="The pace of the course was too fast."
            />
          </RadioGroup>
        </FormControl>
        <Box sx={{ pl: 3, mb: 1.5 }}>
          <p>Additional comments (optional)</p>
          <Box
            component="textarea"
            onChange={(e) => setQuestion3Desc(e.target.value)}
            sx={{ width: "100%", resize: "none", p: 1 }}
          />
        </Box>

        <p style={{ marginTop: "2rem" }}>
          Q5.Please indicate the extent to which you agree or disagree with each
          statement below about the instructor.
        </p>
        <StyledGrid>
          <p></p>
          <p>Strongly disagree</p>
          <p>Disagree</p>
          <p>Neither disagree nor agree</p>
          <p>Agree</p>
          <p>Strongly agree</p>

          <p className="led">
            <p>I am satisfied with the instructor overall</p>
          </p>
          {["0", "1", "2", "3", "4"].map((item) => (
            <p>
              <Radio {...controlProps6(item)} />
            </p>
          ))}
          <p className="led">
            <p>The instructor was knowledgeable about the subject matter</p>
          </p>
          {["0", "1", "2", "3", "4"].map((item) => (
            <p>
              <Radio {...controlProps7(item)} />
            </p>
          ))}
          <p className="led">
            <p>The instructor encouraged question and participation</p>
          </p>
          {["0", "1", "2", "3", "4"].map((item) => (
            <p>
              <Radio {...controlProps8(item)} />
            </p>
          ))}
          <p className="left">
            <p>The instructor explained concepts clearly</p>
          </p>
          {["0", "1", "2", "3", "4"].map((item) => (
            <p>
              <Radio {...controlProps9(item)} />
            </p>
          ))}
        </StyledGrid>
        <Box sx={{ pl: 3, mb: 1.5 }}>
          <p>Additional comments (optional)</p>
          <Box
            component="textarea"
            onChange={(e) => setQuestion4Desc(e.target.value)}
            sx={{ width: "100%", resize: "none", p: 1 }}
          />
        </Box>
        <p style={{ marginTop: "2rem" }}>
          Q6. Please indicate the extent to which you agree or disagree with
          each statement below about Logistics / Organization.
        </p>
        <StyledGrid>
          <p></p>
          <p>Strongly disagree</p>
          <p>Disagree</p>
          <p>Neither disagree nor agree</p>
          <p>Agree</p>
          <p>Strongly agree</p>

          <p className="led">
            <p>The registration process was smooth and effective</p>
          </p>
          {["0", "1", "2", "3", "4"].map((item) => (
            <p>
              <Radio {...controlProps10(item)} />
            </p>
          ))}
          <p className="led">
            <p>The online tool was conductive to learning</p>
          </p>
          {["0", "1", "2", "3", "4"].map((item) => (
            <p>
              <Radio {...controlProps11(item)} />
            </p>
          ))}
        </StyledGrid>
        <Box sx={{ pl: 3, mb: 1.5 }}>
          <p>What did you like the most during the webinar?</p>
          <Box
            component="textarea"
            onChange={(e) => setQuestion5Desc(e.target.value)}
            sx={{ width: "100%", resize: "none", p: 1 }}
          />
        </Box>
        <p style={{ marginTop: "2rem" }}>
          Q7. What additional topics would you like to see USP Education cover?
        </p>
        <Box sx={{ pl: 3, mb: 1.5 }}>
          <Box
            component="textarea"
            onChange={(e) => setQuestion6(e.target.value)}
            sx={{ width: "100%", resize: "none", p: 1 }}
          />
        </Box>
        <p style={{ marginTop: "2rem" }}>
          Q8. Please include any comments of suggestions on how USP Education
          could improve its courses.
        </p>
        <Box sx={{ pl: 3, mb: 1.5 }}>
          <Box
            component="textarea"
            onChange={(e) => setQuestion7(e.target.value)}
            sx={{ width: "100%", resize: "none", p: 1 }}
          />
        </Box>

        <p style={{ marginTop: "2rem" }}>
          Q9. Please fill in the details below.
        </p>
        <Stack direction="column" spacing={1}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Box sx={{ minWidth: "116px", textAlign: "right" }}>Name </Box>
            <Box>
              <TextField
                id="outlined-basic"
                inputProps={{ readOnly: true }}
                variant="outlined"
                size="small"
                defaultValue={userDetails && userDetails.name}
              />
            </Box>
          </Stack>
          <Stack direction="row" alignItems="center" j spacing={2}>
            <Box sx={{ minWidth: "116px", textAlign: "right" }}>Email </Box>
            <Box>
              <TextField
                id="outlined-basic"
                variant="outlined"
                inputProps={{ readOnly: true }}
                defaultValue={userDetails && userDetails.email}
                size="small"
              />
            </Box>
          </Stack>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Box sx={{ minWidth: "116px", textAlign: "right" }}>
              Contact Number{" "}
            </Box>
            <Box>
              <TextField
                id="outlined-basic"
                variant="outlined"
                inputProps={{ readOnly: true }}
                value={userDetails?.uData?.cno || ""}
                size="small"
              />
            </Box>
          </Stack>
          {/* <Stack direction="row" alignItems="center" spacing={2}>
            <Box sx={{ minWidth: "116px", textAlign: "right" }}>
              Organization
            </Box>
            <Box>
              <TextField
                id="outlined-basic"
                variant="outlined"
                size="small"
                onChange={(e) => setOrganization(e.target.value)}
              />
            </Box>
          </Stack>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Box sx={{ minWidth: "116px", textAlign: "right" }}>
              Designation
            </Box>
            <Box>
              <TextField
                id="outlined-basic"
                variant="outlined"
                size="small"
                onChange={(e) => setDesignation(e.target.value)}
              />
            </Box>
          </Stack>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Box sx={{ minWidth: "116px", textAlign: "right" }}>Department</Box>
            <Box>
              <TextField
                id="outlined-basic"
                variant="outlined"
                size="small"
                onChange={(e) => setDepartment(e.target.value)}
              />
            </Box>
          </Stack> */}
        </Stack>
        <Stack
          direction="column"
          alignItems="center"
          justifyContent="center"
          sx={{ mt: 2 }}
        >
          <LoadingButton
            loading={loading ? true : false}
            disabled={loading ? true : false}
            type="submit"
            onClick={() => handleSubmit()}
            sx={StyledButtons}
          >
            Submit
          </LoadingButton>
          {error !== "" && <Box sx={{ color: "red" }}>{error}</Box>}
        </Stack>
      </DialogContent>
    </>
  );
}
